import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
} from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { Link } from "react-router-dom";
// Sample project data (simulate fetched data)
const sampleProjects = [
  { name: "SkyGrid", initials: "SG", color: "#F44336", progress: 55 },
  { name: "Project Quantum", initials: "PQ", color: "#3F51B5", progress: 70 },
  { name: "CodeFusion", initials: "CF", color: "#9C27B0", progress: 85 },
  { name: "Digital Marketing", initials: "DM", color: "#FF9800", progress: 40 },
];

const ProjectsList = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    // Simulate loading delay
    setTimeout(() => {
      setData(sampleProjects);
    }, 2000);
  }, []);

  return (
    <Paper className="card-body p-20 bg-base border rounded-3 h-100" sx={{ boxShadow: 'none' }}>
      <Box display="flex" justifyContent="space-between" className=" pb-16 mb-0 border-bottom">
        <h6 className=" fw-semibold mb-0" style={{ fontSize: '17px' }}>Project  <Tooltip title="Project" arrow placement="top">
          <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
            <InfoOutlineIcon fontSize="small" />
          </button>
        </Tooltip></h6>
        <a href="/my-projects"  style={{ cursor: "pointer", fontSize: '14px', color: '#004DFF', }}>
          View report
        </a>
       
      </Box>
      <TableContainer>
        <Table className="tablegridall">
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell> {/* Serial number header */}
              <TableCell>Project</TableCell>
              <TableCell align="right">Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& .MuiTableCell-root": {
                borderBottom: "none", // 🔥 remove table body cell borders
              },
            }}
          >
            {!data ? (
              <TableRowsLoader rowsNum={4} />
            ) : (
              data.map((project, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell> {/* Serial number */}
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      <Avatar sx={{ bgcolor: project.color, fontSize: '14px' }}>{project.initials}</Avatar>
                      <Box>
                        <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 600, color: '#1A1F36', }}>{project.name}</Typography>
                        <Box display="flex" alignItems="center" gap={1} mt={1}>
                          <LinearProgress
                            variant="determinate"
                            value={project.progress}
                            sx={{ width: 200, height: 8, borderRadius: 4 }}
                          />
                          <Typography variant="body2">{project.progress}%</Typography>
                        </Box>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="caption">24:23:05</Typography>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

// Skeleton loader component with numbering
const TableRowsLoader = ({ rowsNum }) => {
  return [...Array(rowsNum)].map((_, index) => (
    <TableRow key={index}>
      <TableCell>
        <Skeleton animation="wave" variant="text" width={20} />
      </TableCell>
      <TableCell>
        <Box display="flex" alignItems="center" gap={2}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="rectangular" width={150} height={8} sx={{ borderRadius: 4, mt: 1 }} />
          </Box>
        </Box>
      </TableCell>
      <TableCell align="right">
        <Skeleton variant="text" width={60} />
      </TableCell>
    </TableRow>
  ));
};

export default ProjectsList;
